import React from 'react';
import type { ComponentEventHandler } from '@archipro-design/aria';
import { Checkbox } from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import * as S from './ShippingOption.style';
interface Props {
    selected: boolean;
    title: React.ReactNode;
    subTitle: React.ReactNode;
    disabled?: boolean;
    onClick?: ComponentEventHandler<void>;
}

const ShippingOption = ({
    selected,
    title,
    subTitle,
    disabled = false,
    onClick,
}: Props) => {
    const { css } = useStyles({ selected, disabled });

    return (
        <div className={css(S.ShippingOption)} onClick={onClick}>
            <Checkbox
                indicator={{ kind: 'radio' }}
                label={title}
                checked={selected}
                disabled={disabled}
                className={css(S.Radio)}
            />
            <div className={css(S.SubTitle)}>{subTitle ?? ''}</div>
            {disabled && (
                <div className={css(S.DisabledNote)}>Not available</div>
            )}
        </div>
    );
};

export default ShippingOption;
